
exports.pbkdf2 = require('./lib/async')

exports.pbkdf2Sync = require('./lib/sync')



//////////////////
// WEBPACK FOOTER
// E:/topNews_work/topnews-share-sa/node_modules/pbkdf2/browser.js
// module id = 46
// module chunks = 0